var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ZipAddress"},[_c('span',{staticClass:"ZipAddress_Zip"},[_vm._v("〒"+_vm._s(_vm.zipcode))]),_c('span',{staticClass:"ZipAddress_Address"},[_vm._v(_vm._s(this.address || '取得中...'))])])}
var staticRenderFns = []

export { render, staticRenderFns }